export default "__VITE_ASSET__t3T06J8G__"